export default __webpack_public_path__ + "static/media/cp_geo_im.3d2e63e1.svg";